import React from "react";
import { Link } from "react-router-dom";
import { style } from "../styles/Style";
import { MdOutlineSmsFailed } from "react-icons/md";
function LoginRequest() {
  return (
    <div className="w-full flex h-screen bg-red-100">
      <div className="m-auto w-80 p-4 bg-red-300 rounded">
        <div className="flex">
          <MdOutlineSmsFailed className='my-auto text-white mr-2' />{" "}
          <h2 className="text-white font-semibold py-2">
             Authentication Reguired{" "}
          </h2>
        </div>
        <p className="text-xs text-white">
          To access Umushinga services you need to be our authenticated
          user
        </p>
        <div className="flex">
          <Link type="submit" to="/" className={style.LoginReguest}>
            <p className="m-auto">Login</p>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LoginRequest;
